import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

// 创建axios实例
const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器，添加认证令牌
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器，处理常见错误
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 处理401错误（未认证）
    if (error.response && error.response.status === 401) {
      console.warn('API 401错误：清除token并重定向到登录页', {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response.status,
        message: error.response?.data?.message
      });
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // 避免在登录页本身触发重定向循环
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// 用户相关API
export const userApi = {
  // 登录
  login: (username) => {
    return api.post('/api/users/login', { username });
  },
  
  // 获取当前用户信息
  getCurrentUser: () => {
    return api.get('/api/users/me');
  },
  
  // 获取所有用户
  getAllUsers: () => {
    return api.get('/api/users');
  },
  
  // 获取单个用户
  getUserById: (id) => {
    return api.get(`/api/users/${id}`);
  },
  
  // 创建用户
  createUser: (userData) => {
    return api.post('/api/users', userData);
  },
  
  // 更新用户
  updateUser: (id, userData) => {
    return api.put(`/api/users/${id}`, userData);
  },
  
  // 删除用户
  deleteUser: (id) => {
    return api.delete(`/api/users/${id}`);
  }
};

export default api; 